<!--
 * @Desc:
 * @Author: 赵佳明
 * @Date: 2024-04-19 16:55:02
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-23 11:42:40
-->
<template>
    <div class="app-container">
        <div class="anjian-wrap">
            <!-- 搜索 -->
            <div class="common-section-bg anjian-shaixuan">
                <div class="shaixuan-item">
                    <el-input v-model="listQuery.name" clearable style="width: 200px;" placeholder="请输入名称查找" />
                </div>
                <div class="shaixuan-item">
                    <el-select v-model="listQuery.community_id" clearable filterable placeholder="请选择小区">
                        <el-option v-for="item in optionList" :key="item.id" :label="item.commName" :value="item.id" />
                    </el-select>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" @click="handleFilter" icon="el-icon-search">
                        {{ $t("table.search") }}
                    </el-button>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
                        {{ $t("table.add") }}
                    </el-button>
                </div>
            </div>
            <div class="common-section-bg common-section-top biaoge-data">
                <el-table v-loading="listLoading" :data="tableData" style="width: 100%">
                    <el-table-column prop="id" label="id" width="80" />
                    <el-table-column prop="name" label="问卷名称" align="center" min-width="200" />
                    <el-table-column prop="wenjuan_name" label="问卷模板" align="center" min-width="200" />
                    <el-table-column label="封面图" width="200" align="center">
                        <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px" :src="$adddom(scope.row.thumb)"
                                :preview-src-list="[$adddom(scope.row.thumb)]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="生效时间" align="center" width="200" />
                    <el-table-column prop="community" label="小区" align="center" min-width="200" />
                    <el-table-column align="center" label="状态" min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">未发布</span>
                            <span v-if="scope.row.status == 1">已发布</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" fixed="right" width="450">
                        <template slot-scope="scope">
                            <el-button @click="showEdit(scope.row.id)"
                                style="background: #FD962B; border-color: #FD962B" type="primary">
                                编辑
                            </el-button>
                            <el-button type="success" v-if="scope.row.status == 0" @click="toFa(scope.row.id, 1)">
                                发布
                            </el-button>
                            <el-button type="success" @click="shareurl(scope.row.id)">
                                复制链接
                            </el-button>
                            <el-button type="danger" v-if="scope.row.status == 1" @click="toFa(scope.row.id, 0)">
                                暂停
                            </el-button>
                            <el-button type="success" @click="toGuan(scope.row.id)">
                                记录
                            </el-button>
                            <el-button type="success" @click="toTong(scope.row.id)">
                                统计
                            </el-button>
                            <el-button type="danger" @click="delFun(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <!-- 分页 -->
                <pagination v-show="total" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size"
                    @pagination="getList" />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="1000px">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? '编辑' : '新增' }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <el-form ref="ruleForm" :model="params" :rules="rules" label-width="130px">
                    <el-form-item label="问卷名称" prop="name">
                        <el-input v-model="params.name" />
                    </el-form-item>
                    <el-form-item label="封面图" prop="thumb">
                        <image-upload ref="imageUpload" v-if="showUpload"
                            :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸690*250,请自己处理好宽高比例`"
                            :image-list="imageDefaultList" :maxNumber="1"
                            autoCropWidth="690"
                            autoCropHeight="250"
                            @updateImg="onUpdateImg($event)"></image-upload>
                    </el-form-item>
                    <!-- 不可以编辑问卷模板 -->
                    <el-form-item label="问卷模板" prop="wenjuan_id" v-if="isEdit != 1">
                        <el-select v-model="params.wenjuan_id" clearable filterable placeholder="请选择问卷模板">
                            <el-option v-for="item in wenList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="小区" prop="community_ids">
                        <el-select multiple v-model="params.community_ids" clearable filterable placeholder="请选择小区">
                            <el-option v-for="item in optionList" :key="item.id" :label="item.commName"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="begin_at">
                        <el-date-picker v-model="params.begin_at" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="end_at">
                        <el-date-picker v-model="params.end_at" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="fix-fotter">
                    <div class="default-btn pointer" @click="tijiao('ruleForm')">提交
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Qu from "@/api/tianzheng/Qu";
import diaocha from "@/api/tianzheng/diaocha";
import Pagination from '@/components/Pagination';
import ImageUpload from '@/components/Upload/image';
export default {
    components: {
        Pagination,
        ImageUpload
    },
    data() {
        var checkPic = (rule, value, callback) => {
            if (!this.thumbList || this.thumbList.length == 0) {
                return callback(new Error('封面图必须上传'));
            }
        }
        return {
            // 列表搜索参数
            listQuery: {
                name: "",
                community_id: "",
                page: 1,
                size: 10
            },
            total: 0,//总条数
            tableData: [],
            listLoading: false,//表格加载
            optionList: [],//小区下拉数据
            wenList: [],//问卷模板下拉数据
            showDrawer: false,//新增编辑弹出
            isEdit: 0, // 0新增 1编辑
            // 必填规则
            rules: {
                name: [{
                    required: true,
                    message: '请输入问卷名称',
                    trigger: 'blur'
                }],
                wenjuan_id: [{
                    required: true,
                    message: '请选择问卷模板',
                    trigger: 'change'
                }],
                community_ids: [{
                    required: true,
                    message: '请选择小区',
                    trigger: 'change'
                }],
                begin_at: [{
                    required: true,
                    message: '请选择开始时间',
                    trigger: 'change'
                }],
                end_at: [{
                    required: true,
                    message: '请选择结束时间',
                    trigger: 'change'
                }],
                // thumb: [
                //     { required: true, validator: checkPic }
                // ]
            },
            showUpload: false,//封面图显示
            imageDefaultList: [],
            thumbList: [],
            diaochaId: "",//问卷调查id
            // 新增编辑参数
            params: {
                name: "",//名称
                thumb: "",//封面图
                wenjuan_id: "",//问卷id
                community_ids: [],//小区id数组
                begin_at: "",//开始时间
                end_at: "",//结束时间
            },

        };
    },
    created() {
        this.getSelectCity()//小区下拉数据
        this.getSelectWen()//问卷下拉数据
        this.getList();//表格数据
    },
    methods: {
      shareurl(id){
        diaocha.shareUrl({
          id: id
        }).then(res => {
          if (res.code == 200) {
            var sharelink = res.result;
            navigator.clipboard
              .writeText(sharelink)
              .then(() => {
                this.$message.success("复制成功");
              })
              .catch((err) => {
                // 复制失败
                console.error("复制失败");
              });
          } else {
            this.$message.error(res.message)
          }
        })
      },
        // 点击删除
        delFun(id){
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                diaocha.remove({
                    id: id
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.getList(this.listQuery)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        // 点击问卷管理
        toGuan(id){
            this.$router.push({
                path:"/wenjuan/Guanli",
                query:{
                    id:id
                }
            })
        },
        // 点击问卷统计
        toTong(id){
            this.$router.push({
                path:"/wenjuan/Tongji",
                query:{
                    id:id
                }
            })
        },
        // 点击发布、暂停发布
        toFa(id, type) {
            // type:1发布0暂停
            let that = this;
            that.$confirm('是否确认执行此操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                diaocha.status({ id: id, status: type }).then(res => {
                    if (res.code == 200) {
                        that.$message.success(res.message)
                        that.getList(that.listQuery)
                    }
                })
            }).catch(() => {
            })
        },
        // 点击编辑
        showEdit(id) {
            let that = this;
            that.isEdit = 1;
            that.showDrawer = true;
            that.resetForm();
            that.diaochaId = id;
            diaocha.detail({ id: id }).then(res => {
                if (res.code == 200) {
                    let info = res.result;
                    that.params.name = info.name;
                    that.params.thumb = info.thumb;
                    that.params.community_ids = info.community_ids;
                    that.params.begin_at = info.begin_at;
                    that.params.end_at = info.end_at;
                    if (info.thumb) {
                        let imgList = [];
                        let obj = {
                            name: info.thumb,
                            path: info.thumb,
                            url: that.$publicData.imgUrl + info.thumb,
                        }
                        imgList.push(obj);
                        // 回显图
                        that.imageDefaultList = JSON.stringify(imgList);
                    };
                }
            })
        },
        onUpdateImg(val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        // 点击添加
        handleCreate() {
            this.isEdit = 0
            this.showDrawer = true
            this.resetForm()
        },
        // 点击搜索
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        // 表格数据
        getList(val) {
            if (val && val.page) {
                this.listQuery.page = val.page
            }
            this.listLoading = true
            diaocha.list(this.listQuery).then(res => {
                this.listLoading = false
                if (res.code == 200) {
                    this.tableData = res.result.list
                    this.total = res.result.total
                }
            })
        },
        // 获取小区下拉列表
        getSelectCity() {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            })
        },
        // 获取问卷模板下拉列表
        getSelectWen() {
            diaocha.select({}).then(res => {
                if (res.code == 200) {
                    this.wenList = res.result;
                }
            })
        },
        /**
        * @name: 清空
        * @return {*}
        * @desc:
        */
        resetForm() {
            this.params.name = ''
            this.params.thumb = ''
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.showUpload = true;
            if (this.$refs["ruleForm"]) {
                this.$refs["ruleForm"].resetFields();
            }
        },
        /**
          * @name: 关闭弹层
          * @return {*}
          * @desc:
          */
        closeDrawerFun() {
            this.showDrawer = false
            this.resetForm()
        },
        // 提交
        tijiao(formName) {
            // console.log("tijiao");
            let that = this;
            // console.log("refs",that.$refs[formName]);
            that.$refs[formName].validate(valid => {
                // console.log("valid",valid);
                if (valid) {
                    console.log("that.thumbList", that.thumbList);
                    if (that.thumbList.length > 0) {
                        that.params.thumb = that.thumbList[0];
                    }
                    console.log("提交params", that.params);
                    if (that.isEdit == 0) {
                        // 新增
                        diaocha.create(that.params).then(res => {
                            if (res.code == 200) {
                                that.showDrawer = false;
                                that.listQuery.page = 1;
                                that.getList();
                                that.$message.success(res.message);
                            }
                        })
                    } else {
                        that.params.id = that.diaochaId;
                        // 编辑
                        diaocha.edit(that.params).then(res => {
                            if (res.code == 200) {
                                that.showDrawer = false;
                                that.getList(that.listQuery);
                                that.$message.success(res.message);
                            }
                        })
                    }
                }
            })
        }
    }
};
</script>

<style></style>
